(ns frontend.ui.component.lp-portal.report.body.innovestor.fund.pdf.pages.fund-status
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.component.lp-portal.report.component.vertical-table.pdf-view :as vertical-table-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [potpuri.core :as potpuri]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview :refer [empty-table-data?]]))

(defn fund-status-page-2
  [{:keys [fund-status] :as data}]
  (let [remove-page? (and (empty-table-data? fund-status :net-asset-value)
                          (empty-table-data? fund-status :key-metrics))]
    (when-not remove-page?
      (page/page
       (page/page-title-with-line {:fund-name  (:fund-name data)
                                   :page-title "Fund overview - Net asset value and key metrics"
                                   :toc-item   true
                                   :reporting-period (:reporting-period data)})
       (card/table-card ""
                        (horizontal-table-pdf/table (->> fund-status
                                                         :net-asset-value))
                        (text-content/optional-footer (->> fund-status
                                                           :net-asset-value)))
       (card/table-card ""
                        (vertical-table-pdf/table (->> fund-status
                                                       :key-metrics))
                        (text-content/optional-footer (->> fund-status
                                                           :key-metrics)))))))

(defn fund-status-pages
  [data]
  [(fund-status-page-2 data)])
